import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { Role } from './role.model';
import { config } from '../../../../config';

@Injectable()
export class RoleService {
  private endpoint: string = `${config.apiLocation}/admin/roles`;

  constructor(private http: HttpClient) {}

  get(): Observable<Role[]> {
    return this.http
      .get<{ data: Role[] }>(`${this.endpoint}`)
      .map(res => res.data);
  }

  getById(id): Observable<Role> {
    return this.http
      .get<{ data: Role }>(`${this.endpoint}/${id}`)
      .map(res => res.data);
  }

  create(role: Role): Observable<Role> {
    return this.http
      .post<{ data: Role }>(`${this.endpoint}`, role)
      .map(res => res.data);
  }

  update(role: RecursivePartial<Role>): Observable<Role> {
    return this.http
      .patch<{ data: Role }>(`${this.endpoint}/${role.id}`, role)
      .map(res => res.data);
  }

  delete(roleId: string) {
    return this.http.delete<void>(`${this.endpoint}/${roleId}`, {});
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/roles/role.service.ts